import { useEffect, useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { ROUTE_PARAM } from 'constants/api-constants';
import { DEFAULT_LOCALE, type Locales } from 'constants/app';
import InvoicePage from 'pages/invoice/page';
import NotFound from 'pages/not-found';
import PaymentViewPage from 'pages/payment/view/page';
import CheckViewPage from 'pages/payment/viewcheck/page';
import { setLocale } from 'store/app/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getIntlMessages } from 'utils';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <div>Главная страница</div>,
      errorElement: <NotFound />,
    },
    {
      path: '/invoice',
      element: <InvoicePage />,
    },
    {
      path: '/payment/view',
      element: <PaymentViewPage />,
    },
    {
      path: '/payment/viewcheck',
      element: <CheckViewPage />,
    },
  ],
  {
    basename: ROUTE_PARAM,
  },
);

const App = () => {
  const { locale } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();
  const messages = useMemo(() => getIntlMessages(locale || DEFAULT_LOCALE), [locale]);

  useEffect(() => {
    const localeFromLS = localStorage.getItem('locale');

    if (window.location.hash !== '') {
      const pathLocale = window.location.hash.replace(/#/, '');

      if (localeFromLS !== pathLocale) {
        dispatch(setLocale(pathLocale as Locales));
        localStorage.setItem('locale', pathLocale);
        window.location.hash = `#${pathLocale}`;
      } else {
        dispatch(setLocale(localeFromLS as Locales));
      }
    } else {
      window.location.hash = `#${DEFAULT_LOCALE}`;
      localStorage.setItem('locale', DEFAULT_LOCALE);
      dispatch(setLocale(DEFAULT_LOCALE));
    }
  }, [dispatch]);

  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale={DEFAULT_LOCALE}>
      <RouterProvider router={router} />
    </IntlProvider>
  );
};

export default App;
